export default __webpack_public_path__ + "static/media/filter_plus.cae3f7b3.svg";